import React from 'react'
import CaretDown from '../components/CaretDown'
import { db } from '../..'
import { ref, set } from 'firebase/database'
import OpenModal from './OpenModal'

const ImportGamepack = ({userData}) => {
    const [gamepack, setGamepack] = React.useState(null) // ゲームパックの状態を管理
    const [currentStep, setCurrentStep] = React.useState(0) // 現在のステップを管理
    const [gameDate, setGameDate] = React.useState(null) // ゲーム開始日時の状態を管理
    const [openModal, setOpenModal] = React.useState(false) // モーダルの状態を管理

    // ゲームパックをインポートして格納
    const handleImportGamepack = (event) => {
        console.log(event)
        const file = event.target[0].files[0]
        if (file) {
            const reader = new FileReader()
            reader.onload = (e) => {
                try {
                    const data = JSON.parse(e.target.result)
                    console.log(data)

                    // ゲームバックファイルの型を確認
                    if(!(data.info && data.info.package && data.missions)) {
                        alert('ゲームパックの形式が正しくありません。')
                        setCurrentStep(0) // ステップをリセット
                        return
                    }

                    setGamepack(data)
                    setCurrentStep(1) // ステップを進める
                } catch (error) {
                    alert('ゲームパックのインポートに失敗しました。')
                }
            }
            reader.readAsText(file)
        }
    }

    // 開始日時が編集されたときの処理
    React.useEffect(() => {
        const currentDate = new Date()
        const inputDate = new Date(gameDate)

        if (inputDate > currentDate) {
            setCurrentStep(2) // ステップを進める
        }
    }, [gameDate])

    // ゲームデータを保存する
    const saveGameData = () => {
        if (!gamepack) return

        // ゲームパック内のゲーム開始時刻と、入力したゲーム開始時刻の差分を見て、
        // ・逃走準備終了時刻、ゲーム終了時刻を変更する
        // ・各ミッションの開始時刻を変更する

        // 開始時刻の差分を計算
        const gameStartTime = new Date(gamepack.info.startTime)
        const inputStartTime = new Date(gameDate)
        const timeDiff = inputStartTime - gameStartTime

        let newGamepack = { ...gamepack }
        newGamepack.info.startTime = dateToDatetimeLocal(inputStartTime)
        newGamepack.info.prepareLimitTime = dateToDatetimeLocal(new Date(gamepack.info.prepareLimitTime).getTime() + timeDiff)
        newGamepack.info.endTime = dateToDatetimeLocal(new Date(gamepack.info.endTime).getTime() + timeDiff)
        
        // ゲームパックのミッションの開始時刻を変更
        const updatedMissions = gamepack.missions.map(mission => {
            const missionStartTime = new Date(mission.time.start)
            mission.time.start = dateToDatetimeLocal(missionStartTime.getTime() + timeDiff)
            return mission
        })

        newGamepack.missions = updatedMissions;
        console.log(newGamepack)

        // Realtime Databaseに保存する
        //ランダムなゲームIDを生成（英数6桁）
        const gameId = Math.random().toString(36).slice(2, 8)
        const gameRef = ref(db, 'games/' + gameId)
        set(gameRef, newGamepack)
        .then(() => {
            // ユーザーデータにゲームIDを追加
            const userRef = ref(db, 'users/' + userData.uid + '/createdGames/' + gameId)
            return set(userRef, gameId)
            .then(() => {
                console.log('ユーザーデータにゲームIDを追加しました。')
                setOpenModal(true) // モーダルを開く
            })
        })
        .catch((error) => {
            console.error('ゲームデータの保存に失敗しました。', error)
            alert('ゲームデータの保存に失敗しました。')
        })


        console.log('ゲームデータを保存しました。')
    }

    // Date型からinputのdatetime-local形式に変換（時差を考慮）
    const dateToDatetimeLocal = (date) => {
        const dateObj = new Date(date);
        const localDate = new Date(dateObj.getTime() + 9 * 60 * 60 * 1000); // JSTに変換
        return localDate.toISOString().slice(0, 16); // YYYY-MM-DDTHH:mm形式に変換
    }

    return (
        <div className='max-w-3xl mx-auto my-4 px-3'>
            <h2 className='text-center text-2xl mb-6'>ゲームパックを開封</h2>

            {/* ゲームパック販売サイトへの誘導 */}
            <div className='bg-white shadow-sm rounded-lg p-4 mb-6 max-w-2xl mx-auto'>
                <h3 className='text-gray-800 font-semibold text-lg mb-2'>ゲームパックをさがす</h3>
                <p className='text-gray-600 text-base'>「電鬼™」公式の鬼ごっこと同じ内容であそべる！<br/>オンラインストアでさがしてみましょう！</p>
                <div className='flex justify-center items-center mt-4'>
                    <a href="https://traffic-tag-shop.square.site/" target="_blank" rel="noopener noreferrer" className='text-white hover:shadow-sm bg-gradient-to-r from-violet-500 via-purple-500 to-fuchsia-500 p-2 rounded-lg w-full text-center text-lg tracking-wider'>
                        <i className='bi bi-bag mx-2'></i>ゲームパック ストア
                    </a>
                </div>
            </div>

            <hr className='border-purple-300 my-6' />

            {/* ファイルを参照してインポート */}
            <div className='bg-white shadow-sm rounded-lg p-4 mb-6 max-w-2xl mx-auto'>
                <h3 className='text-purple-800 font-semibold text-lg mb-2'><i className='bi bi-gift me-2'></i>ゲームパックを開封</h3>
                <p className='text-gray-600 text-base'>ゲームパックのファイルを選択してください。</p>

                <form onSubmit={(e) => { e.preventDefault(); handleImportGamepack(e) }}>
                    <input type="file" accept=".json" className='border border-gray-300 rounded-lg p-2 w-full mt-2' />

                    <div className='flex justify-end'>
                        <button type="submit" className='bg-purple-500 hover:bg-purple-600 text-white rounded-lg px-4 py-2 mt-4'>開封する</button>
                    </div>
                </form>
            </div>

            { currentStep > 0 && (
                <>
                    <CaretDown />

                    <div className='bg-white shadow-sm rounded-lg p-4 mb-6 max-w-2xl mx-auto'>
                        <h3 className='text-purple-800 font-semibold text-lg mb-2'><i className='bi bi-calendar3 me-2'></i>実施日時の設定</h3>
                        <p className='text-gray-600 text-base'>ゲームを開始する日時を入力してください。この時刻に合わせてゲームが進行します。</p>
                        
                        <div className='m-4'>
                            <label htmlFor="start-time" className='text-gray-600 text-sm'>開始日時</label>
                            <input value={gameDate} onChange={(e) => setGameDate(e.target.value)} type="datetime-local" className='border border-gray-300 rounded-lg p-2 w-full' />
                        </div>
                    </div>
                </>
            )}

            { currentStep > 1 && (
                <>
                    <CaretDown />

                    <div className='bg-white shadow-sm rounded-lg p-4 mb-6 max-w-2xl mx-auto'>
                        <h3 className='text-purple-800 font-semibold text-lg mb-2'><i className='bi bi-floppy me-2'></i>ゲームデータを保存</h3>
                        <p className='text-gray-600 text-base'>あなたが運営するゲームのデータとして保存します。</p>

                        <div className='flex justify-center'>
                            <button onClick={() => saveGameData()} className='bg-purple-500 hover:bg-purple-600 text-white rounded-lg px-4 py-2 mt-4'>
                                <i className='bi bi-save me-2'></i>保存する
                            </button>
                        </div>
                    </div>
                </>
            )}

            <OpenModal isOpen={openModal} onClose={() => {setOpenModal(false); setCurrentStep(0)}} />
        </div>
    )
}

export default ImportGamepack